import { isFilled } from "./general";

export const hasValidReferralSubcategoryIdentity = (subcategory) => {
  return Boolean(
    subcategory &&
      isFilled(subcategory.id) &&
      subcategory.name &&
      subcategory.name.trim(),
  );
};

export const filterValidReferralSubcategories = (subcategories) => {
  return Array.isArray(subcategories)
    ? subcategories.filter(hasValidReferralSubcategoryIdentity)
    : subcategories;
};
